import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PageLayout from "../components/PageLayout";

const ContactsPage = () => {
  const { t } = useTranslation();

  return (
    <PageLayout>
      <Helmet>
        <title>
          {t("nav.contacts")} · {t("app.name")}
        </title>
      </Helmet>

      <div className="flex-1 flex items-center justify-center px-5 py-20 animate-fade-in">
        <div className="w-full max-w-lg">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-xs text-slate-500 hover:text-aviation-cyan transition-colors duration-200 mb-8 focus-visible:ring-2 focus-visible:ring-aviation-cyan rounded"
          >
            ← {t("nav.airports")}
          </Link>

          <h1 className="text-3xl md:text-5xl font-extrabold text-white mb-4">
            {t("nav.contacts")}
          </h1>
          <p className="text-slate-400 text-sm mb-10 leading-relaxed">
            {t("contactPage.text")}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <a
              href="mailto:mmuxish@gmail.com"
              target="_blank"
              rel="noreferrer"
              className="glass-card rounded-card p-5 shadow-card hover:border-aviation-cyan/40 transition-all duration-300 group focus-visible:ring-2 focus-visible:ring-aviation-cyan"
            >
              <p className="text-xs font-bold text-aviation-cyan tracking-widest uppercase mb-2">
                {t("contactPage.email")}
              </p>
              <p className="font-mono text-sm text-slate-300 group-hover:text-white transition-colors duration-200">
                mmuxish@gmail.com
              </p>
            </a>

            <a
              href="https://t.me/muhriddin_murodov"
              target="_blank"
              rel="noreferrer"
              className="glass-card rounded-card p-5 shadow-card hover:border-aviation-cyan/40 transition-all duration-300 group focus-visible:ring-2 focus-visible:ring-aviation-cyan"
            >
              <p className="text-xs font-bold text-aviation-cyan tracking-widest uppercase mb-2">
                {t("contactPage.telegram")}
              </p>
              <p className="font-mono text-sm text-slate-300 group-hover:text-white transition-colors duration-200">
                t.me/muhriddin_murodov
              </p>
            </a>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default ContactsPage;
